import axios from "axios"

const BASE_URL = process.env.VUE_APP_API_URL

const api = axios.create({
    baseURL: BASE_URL,
})


api.interceptors.response.use(response => {
    if (
        response.request?.responseType === 'arraybuffer' ||
        response.request?.responseType === 'blob' ||
        response.data instanceof ArrayBuffer ||
        response.data instanceof Blob
    ) {
        return response;
    }

    if (response.data?.forceLogout === true) {
        window.location.replace("https://erp.nixloc.com.br/login");
        return;
    }

    if (response.data?.data !== undefined) {
        response.data = response.data.data;
    }

    return response;
});


export default api

